import { API, API_GET } from "../../config"

export const GetEducation = () => {
  return (
    API_GET(API.Education)
  )
}